// Minimal Sentry setup (production + DSN only)
import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (process.env.NODE_ENV !== 'production' || !dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0,
    // Keep PII off by default; capture minimal context.
    sendDefaultPii: false,
    beforeSend(event) {
      // Do not forward customer content from errors, breadcrumbs or request URLs.
      return {
        event_id: event.event_id,
        timestamp: event.timestamp,
        level: event.level || 'error',
        platform: event.platform,
        exception: { values: [{ type: 'ApplicationError', value: 'Application error' }] },
      };
    },
  });
}
